<!--
  @author:sunluhua
  @time:2020/9/14
  @disc:销售计划导出3
 -->
<template>
  <div class="sale-query">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="100px">
      <el-form-item label="单据编号" prop="ces5">
        <el-input v-model="form.ces5" placeholder="请输入单据编号"></el-input>
      </el-form-item>
      <el-form-item label="订单号" prop="ces6">
        <el-input v-model="form.ces6" placeholder="请输入单据编号"></el-input>
      </el-form-item>
      <el-form-item label="支付方式" prop="ces7">
        <el-select v-model="form.ces7" placeholder="请选择">
          <el-option
            v-for="item in ces7"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经营组织" prop="ces4">
        <ajax-select
          v-model="form.organization"
          type="org"></ajax-select>
      </el-form-item>
      <el-form-item label="客户名称" prop="ces5">
        <search-select
          v-model="form.custom"
          type="customer"
          valueField="id"
          clearable
          placeholder="请输入客户名称"></search-select>
      </el-form-item>
      <el-form-item label="币种" prop="ces3">
        <el-select v-model="form.ces3" placeholder="请选择">
          <el-option
            v-for="item in moneyType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="审核状态" prop="auditStatus">
        <el-select v-model="form.auditStatus" placeholder="请选择">
          <el-option
            v-for="item in auditStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="推送电子报账状态" prop="pushERStatus">
        <el-select v-model="form.pushERStatus" placeholder="请选择">
          <el-option
            v-for="item in pushERStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报账人一卡通号" prop="icCardNo">
        <el-input v-model="form.icCardNo" placeholder="请输入报账人一卡通号"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="tareWeightTime">
        <el-date-picker
          v-model="form.tareWeightTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
        <el-button type="primary" v-permission="'0210601'" @click="resetAccount">重推电子报账</el-button>
        <!-- <el-button type="primary">重推电子报账</el-button> -->
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      tooltip-effect="light"
      ref="multipleTable">
      <el-table-column
        prop="receiptNo"
        label="单据编号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="takeOrderNo"
        label="订单号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="currencyType"
        label="币种"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-show="scope.row.currencyType == '1'">CNY</span>
          <span v-show="scope.row.currencyType == '2'">USD</span>
          <span v-show="scope.row.currencyType == '3'">EUR</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="supplementType"
        label="支付方式"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-show="scope.row.supplementType == '1'">现金</span>
          <span v-show="scope.row.supplementType == '2'">刷卡</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="supplementAmount"
        label="补款金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="customerName"
        label="客户名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="orgName"
        label="经营组织"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="agreementNo"
        label="协议编号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="auditStatus"
        label="审核状态"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-show="scope.row.auditStatus == '1'">未审核</span>
          <span v-show="scope.row.auditStatus == '2'">审核通过</span>
          <span v-show="scope.row.auditStatus == '3'">审核不通过</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="推送电子报账状态"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-show="scope.row.status == '1'">推送失败</span>
          <span v-show="scope.row.status == '2'">已推送</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="icCardNo"
        label="报账人一卡通号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="auditTime"
        label="审核时间"
        show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <div>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AjaxSelect from '../../../components/ajaxSelect/index'
import SearchSelect from '../../../components/searchSelect/index'
import MultiCascader from '../../../components/multiCascader/multi-cascader-base-element/multiCascader'

export default {
  name: 'saleQuery',
  components: { AjaxSelect, SearchSelect, MultiCascader },
  data () {
    return {
      form: {
        tareWeightTime: []
      },
      tableData: [],
      addData: {},
      ces6: [
        { value: 1, label: '是' },
        { value: 2, label: '否' }
      ],
      ces7: [
        { value: '', label: '全部' },
        { value: 1, label: '现金' },
        { value: 2, label: '刷卡' }
      ],
      moneyType: [
        { value: '', label: '全部' },
        { value: 1, label: 'CNY' },
        { value: 2, label: 'USD' },
        { value: 3, label: 'EUR' }
      ],
      auditStatusList: [
        { value: '', label: '全部' },
        { value: 1, label: '未审核' },
        { value: 2, label: '审核通过' },
        { value: 3, label: '审核不通过' }
      ],
      pushERStatusList: [
        { value: '', label: '全部' },
        { value: 1, label: '推送失败' },
        { value: 2, label: '已推送' }
      ],
      saleType: [
        { value: 1, label: '全部' },
        { value: 2, label: '经营组织1' },
        { value: 3, label: '经营组织2' }
      ],
      list: [
        {
          ces1: 'DS202210271234',
          ces2: 'DS202210271234',
          ces3: 'CNY',
          ces4: '现金',
          ces5: '1000,000,000',
          ces6: '李大志有限公司',
          ces7: '山东中油胜利石化有限公司',
          ces8: '2222',
          ces9: '未审核',
          ces10: '推送失败',
          ces11: '2022-10-27 12:00:00',
          ces12: '2022-10-27 12:00:00'
        },
        {
          ces1: 'DS202210271234',
          ces2: 'DS202210271234',
          ces3: 'CNY',
          ces4: '刷卡',
          ces5: '9999,999,999.01',
          ces6: '李大志有限公司',
          ces7: '山东中油胜利石化有限公司',
          ces8: '2222',
          ces9: '未审核',
          ces10: '推送失败',
          ces11: '2022-10-27 12:00:00',
          ces12: '2022-10-27 12:00:00'
        },
        {
          ces1: 'DS202210271234',
          ces2: 'DS202210271234',
          ces3: 'CNY',
          ces4: '刷卡',
          ces5: '9999,999,999.01',
          ces6: '李大志有限公司',
          ces7: '山东中油胜利石化有限公司',
          ces8: '2222',
          ces9: '未审核',
          ces10: '推送失败',
          ces11: '2022-10-27 12:00:00',
          ces12: '2022-10-27 12:00:00'
        },
        {
          ces1: 'DS202210271234',
          ces2: 'DS202210271234',
          ces3: 'CNY',
          ces4: '刷卡',
          ces5: '9999,999,999.01',
          ces6: '李大志有限公司',
          ces7: '山东中油胜利石化有限公司',
          ces8: '2222',
          ces9: '未审核',
          ces10: '推送失败',
          ces11: '2022-10-27 12:00:00',
          ces12: '2022-10-27 12:00:00'
        }
      ],
      citisOptions: [],
      total: 0,
      listState: {
        pageSize: 10,
        pageNo: 1
      },
      addModalVisible: false
    }
  },
  methods: {
    ...mapActions([
      'getCashList',
      'getPushs'
    ]),
    // 搜索
    handleSearch () {
      console.log('jashjdhashdk')
      const params = {
        // adjustType: this.form.ces2[0],
        receiptNo: this.form.ces5,
        takeOrderNo: this.form.ces6,
        supplementType: this.form.ces7,
        // currencyTypeList: this.form.ces3,
        currencyType: this.form.ces3,
        orgId: this.form.organization,
        customerId: this.form.custom,
        auditStatus: this.form.auditStatus === '' ? null : this.form.auditStatus,
        pushERStatus: this.form.pushERStatus === '' ? null : this.form.pushERStatus,
        icCardNo: this.form.icCardNo,
        // createTimeStart: this.form.tareWeightTime[0].substring(0, 10),
        // createTimeEnd: this.form.tareWeightTime[1].substring(0, 10),
        ...this.listState
      }
      if (this.form.tareWeightTime === null) {
        console.log(this.form.tareWeightTime)
        this.form.tareWeightTime = []
      }
      if (this.form.tareWeightTime.length === 2) {
        params.createTimeStart = this.form.tareWeightTime[0] + ' 00:00:00'
        params.createTimeEnd = this.form.tareWeightTime[1] + ' 23:59:59'
        console.log(params)
      }
      this.getCashList(params).then(res => {
        console.log(res, '8888')
        const { list, total, pageNum, pageSize } = res
        this.tableData = list
        this.total = total
        this.listState.pageNo = pageNum
        this.listState.pageSize = pageSize
      })
    },
    // 分页条数变更
    handleSizeChange (val) {
      console.log(val)
      this.listState.pageSize = val
      this.handleSearch()
    },
    // 分页跳转
    handleCurrentChange (val) {
      console.log(val)
      this.listState.pageNo = val
      this.handleSearch()
    },
    resetAccount () {
      console.log('888')
      this.getPushs().then(res => {
        console.log(res, '8888')
        this.$message.success('重推电子报账成功')
        this.handleSearch()
      })
    },
    // 查询表单，表格重置
    handleReset () {
      this.form.pageNo = 1
      this.form.pageSize = 20000
      this.form.organization = ''
      this.form.custom = ''
      this.$refs['form'].resetFields()
      // this.$refs['citisSelector'].reset()
      this.handleSearch()
    }
  },
  mounted () {
    this.isCheckRecord = ''
    this.form.orderTime = ''
    this.handleSearch()
  }
}
</script>

<style scoped>
.output-box{
margin-top: 20px;
text-align: right;
}
.input-page, .select-page{
  width: 98px;
  margin: 0 15px;
}
.input-page, .select-page-btn{
  width: 120px;
  margin: 0 15px;
}
.export-row {
  margin-top: 10px;
}
.width100{
  width: 100px;
}
</style>
